import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  TemplateCategory,
  TemplateCategoryRequest,
  TemplateCategoryFilters,
  TemplateCategoryResult,
  UpdateTemplateCategoryPayload,
} from "../../schemas/templateCategorySchema";

const GET_TEMPLATE_CATEGORIES = gql`
  query GetTemplateCategories($page: Int, $pageSize: Int, $search: String) {
    templateCategories(page: $page, pageSize: $pageSize, search: $search) {
      templateCategories {
        id
        name
        description
        tenantId
        createdBy
        createdAt
        updatedAt
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_TEMPLATE_CATEGORY_BY_ID = gql`
  query GetTemplateCategoryById($id: ID!) {
    templateCategory(id: $id) {
      id
      name
      description
      tenantId
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const CREATE_TEMPLATE_CATEGORY = gql`
  mutation CreateTemplateCategory($input: CreateTemplateCategoryInput!) {
    createTemplateCategory(input: $input)
  }
`;

const UPDATE_TEMPLATE_CATEGORY = gql`
  mutation UpdateTemplateCategory(
    $id: ID!
    $input: UpdateTemplateCategoryInput!
  ) {
    updateTemplateCategory(id: $id, input: $input)
  }
`;

const DELETE_TEMPLATE_CATEGORIES = gql`
  mutation DeleteTemplateCategories($ids: [ID!]!) {
    deleteTemplateCategories(ids: $ids)
  }
`;

export const templateCategoryService = {
  getAll: async (
    filters: TemplateCategoryFilters = {},
  ): Promise<TemplateCategoryResult> => {
    const { data } = await client.query({
      query: GET_TEMPLATE_CATEGORIES,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.templateCategories;
  },

  getById: async (id: string): Promise<TemplateCategory> => {
    const { data } = await client.query({
      query: GET_TEMPLATE_CATEGORY_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.templateCategory;
  },

  create: async (input: TemplateCategoryRequest): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_TEMPLATE_CATEGORY,
      variables: { input },
    });
    return data.createTemplateCategory;
  },

  update: async (payload: UpdateTemplateCategoryPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_TEMPLATE_CATEGORY,
      variables: {
        id: payload.id,
        input: payload.templateCategory,
      },
    });
    return data.updateTemplateCategory;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_TEMPLATE_CATEGORIES,
      variables: { ids },
    });
    return data.deleteTemplateCategories;
  },
};
